import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMenu = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 7H19M1 1H19M1 13H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgMenu);
const Memo = memo(ForwardRef);
export default Memo;
